<template>
  <div>
    <button class="btn btn-block btn-info mb-1" @click="duvidas" title="Tire suas dúvidas aqui">
        <div class="text-center">
          <font-awesome-icon
            class="mr-2"
            :icon="['fas', 'question-circle']"
            @click="duvidas"
            title="Informações importantes"
          />
        <span>Tire suas dúvidas!</span>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    duvidas() {
      const win = window.open(
        "https://prefeitura.pbh.gov.br/desenvolvimento/estamos-juntos-inclusao-produtiva-de-pessoas-em-situacao-de-rua",
        "_blank"
      );
      win.focus();
    }
  }
};
</script>

<style>
</style>